"use strict";

(function(z){

    z.tariffVendorAdminForm = z.FormView.extend({

        /**
         * Consts for status
         */
        STATUS_ACTIVE: 1,
        STATUS_INACTIVE: 0,

        SERVICE_FORM_URL: '/tariff-vendor/create/form/service/{service}/tariff/{tariff}',
        SERVICE_VENDORS_URL: '/api/vendors/service/{service}',
        DATE_FORMAT: 'DD-MM-YYYY',
        el: "#tariffVendorForm-modal",

        /**
         * Constructor.
         *
         * @return {undefined}
         */
        initialize: function(){
            $("#tariffVendorForm-vendor-field").chosen({ placeholder_text_multiple: "--Alege vendorul--"});
            z.FormView.prototype.initialize.apply(this, arguments);

            this.initializeEvents();
            this._initializeDateFields();
            this._removeAllServiceFieldValidations(this.model);
        },
        _initializeDateFields: function() {

            $('.datepicker').daterangepicker({
                autoApply: true,
                autoUpdateInput: false,
                singleDatePicker: true,
                showDropdowns: false,
                locale: {
                    format: this.DATE_FORMAT
                }
            });

            // this is official solution for initial empty field
            this.$('#tariffVendorForm-dateStart-field').on('apply.daterangepicker', function (ev, picker) {
                this.$('#tariffVendorForm-dateStart-field').val(picker.startDate.format(this.DATE_FORMAT));
            }.bind(this));

            this.$('#tariffVendorForm-dateStart-field').on('cancel.daterangepicker', function () {
                $(this).val('');
            });
            this.$('#tariffVendorForm-dateEnd-field').on('apply.daterangepicker', function (ev, picker) {
                this.$('#tariffVendorForm-dateEnd-field').val(picker.startDate.format(this.DATE_FORMAT));
            }.bind(this));

            this.$('#tariffVendorForm-dateEnd-field').on('cancel.daterangepicker', function () {
                $(this).val('');
            });
            $('#tariffVendor-dateStart-field').on('apply.daterangepicker', function (ev, picker) {
                $('#tariffVendor-dateStart-field').val(picker.startDate.format(this.DATE_FORMAT));
            }.bind(this));

            $('#tariffVendor-dateStart-field').on('cancel.daterangepicker', function () {
                $(this).val('');
            });
            $('#tariffVendor-dateEnd-field').on('apply.daterangepicker', function (ev, picker) {
                $('#tariffVendor-dateEnd-field').val(picker.startDate.format(this.DATE_FORMAT));
            }.bind(this));

            $('#tariffVendor-dateEnd-field').on('cancel.daterangepicker', function () {
                $(this).val('');
            });
        },

        /**
         * Initialize the events.
         *
         * @return {undefined}
         */
        initializeEvents: function() {
            this.$("#tariffVendorForm-worksite-field").chosen({
                search_contains: true,
                width: "100%"
            });

            this.$("#tariffVendorForm-service-field").chosen({
                search_contains: true,
                width: "100%"
            });
            this.$("#tariffVendorForm-service-field").change(
                function(){
                    z.tariffVendorAdminForm._onServiceChange(false);
                }
            );
            this.$("#tariffVendorForm-allVendors-field").click(
                function(){
                    z.tariffVendorAdminForm._onAllVendorsChange();
                }
            );
        },
        _onAllVendorsChange : function(){

            var $allVendorsField = $('#tariffVendorForm-allVendors-field');
            var $vendorField = $('#tariffVendorForm-vendor-field');
            z.tariffVendorAdminForm._toggle([$vendorField]);
            if($allVendorsField.prop('checked') == true){
                delete this.model.validation['vendor'];
            }
            else{
                this.model.validation['vendor'] = [{
                    required : true,
                    msg: Translator.trans("js.error_message_tariffVendor_vendor_required")
                }];
            }
        },
        /**
         * Get add entity route name.
         *
         * @return {string} - add entity route name
         */
        getAddEntityRouteName: function() {
            return 'addTariffVendorAdmin';
        },

        /**
         * Get edit entity route name.
         *
         * @return {string} - edit entity route name
         */
        getEditEntityRouteName: function() {
            return 'editTariffVendorAdmin';
        },

        /**
         * Get modal form add title text
         *
         * @return {string} - modal form add title text
         */
        getModalFormAddTitleText: function() {
            return Translator.trans('js.btn_add_tariff_vendor');
        },

        /**
         * Get modal form edit title text
         *
         * @return {string} - modal form edit title text
         */
        getModalFormEditTitleText: function() {
            return Translator.trans('js.btn_edit_tariff_vendor');
        },

        /**
         * Get error panel container id.
         *
         * @return {string} - the error panel id
         */
        getErrorPanelId: function() {
            return '#tariffVendorForm-error-panel';
        },

        /**
         * Get submit button selector.
         *
         * @return {string} - the submit button selector
         */
        getSubmitButtonSelector: function() {
            return '#tariffVendorForm-save-button';
        },

        /**
         * Get page path.
         *
         * @return {string} - the page path
         */
        getPagePath: function() {
            return '/tariff-vendor-admin';
        },

        /**
         * Get success event name.
         *
         * @return {string} - the success event name
         */
        getSuccessEventName: function() {
            return 'tariffVendor.success';
        },

        /**
         * Get form error message text.
         *
         * @return {string} - form error message text
         */
        getFormErrorMessageText: function() {
            return Translator.trans('js.error_message_tariffVendorForm');
        },

        /**
         * Set custom labels for the reseller modal form
         *
         * @param {string} action - action name
         * @return {undefined}
         */
        setCustomLabels: function(action) {

            // todo uncomment when API Details will be implemented
            switch (action) {
                case 'add':
                    // this._modifyModalGenerateButton(Translator.trans('js.btn_generate'));
                    break;
                case 'edit':
                    // this._modifyModalGenerateButton(Translator.trans('js.btn_regenerate'));s
                    break;
            }
        },

        /**
         * Collecting data from form inputs.
         *
         * @private
         */
        getFormData: function() {

            var $vendorField         = this.$('#tariffVendorForm-vendor-field');
            var $serviceField          = this.$('#tariffVendorForm-service-field');
            var $valueField         = this.$('#tariffVendorForm-value-field');
            var $dateStartField = this.$('#tariffVendorForm-dateStart-field');
            var $dateEndField           = this.$('#tariffVendorForm-dateEnd-field');
            var $allVendors          = this.$('#tariffVendorForm-allVendors-field');
            var $param = [];

            var $return =  {
                'vendor': $vendorField.val(),
                'service': $serviceField.val(),
                'value': $valueField.val(),
                'dateStart': $dateStartField.val(),
                'dateEnd': $dateEndField.val(),
                'allVendors': $allVendors.is(":checked"),
            };
            var params = $("#tariffVendorForm-service-container").children();
            params.each(function( index, value ) {
                var fieldName = $(this).data('validation');
                var value = $('#tariff_vendor_form_' + fieldName).val();
                $return[fieldName] = value;
            });

            return $return;
        },

        /**
         * Method that fills the form input fields with data coming from the model.
         * It is used when the form is being edited.
         *
         * @private
         * @return {undefined}
         */
        _fillForm: function() {

            var map = {
                'tariffVendorForm-worksite-field'           : 'worksite',
                'tariffVendorForm-service-field'            : 'service',
                'tariffVendorForm-value-field'              : 'value',
                'tariffVendorForm-dateStart-field'          : 'dateStart',
                'tariffVendorForm-dateEnd-field'            : 'dateEnd',
                'tariffVendorForm-allWorksites-field'            : 'allWorksites',
            };

            Object.keys(map).forEach(function(key){

                var value = this.model.get(map[key]);
                switch (key) {

                    case "tariffVendorForm-worksite-field":
                        if(typeof value === 'undefined'){
                            return;
                        }
                        value.forEach(function(v){
                            if(typeof v === 'undefined'){
                                return;
                            }
                            $("#" + key)
                                .find('option[value=' + v.worksiteId + ']').prop('selected', true)
                                .end().trigger('chosen:updated');
                        });
                        break;
                    case "tariffVendorForm-service-field":
                        if(typeof value === 'undefined'){
                            return;
                        }
                        this.$("#" + key)
                            .find('option[value=' + value.id + ']').prop('selected', true)
                            .end().trigger('chosen:updated');
                        break;

                    case "tariffVendorForm-value-field":

                        if(typeof value === 'undefined'){

                            this.$el.find("#"+key).val(0);
                        } else {

                            this.$el.find("#"+key).val(value);
                        }
                        break;

                    case "tariffVendorForm-dateStart-field":
                    case "tariffVendorForm-dateEnd-field":

                        if(typeof value === 'undefined'){

                            this.$el.find("#"+key).val('');
                        } else {
                            var now = new Date(value);
                            var day = ("0" + now.getDate()).slice(-2);
                            var month = ("0" + (now.getMonth() + 1)).slice(-2);
                            var date = (day) +"-"+(month)+"-" + now.getFullYear();
                            this.$el.find("#"+key).val(date);
                        }

                        break;

                    default:
                        this.$el.find("#"+key).val(value);
                }

            }.bind(this));
            z.tariffVendorAdminForm._onServiceChange(true);
        },

        /**
         * Method that edits the entity when the correct route is being reached.
         *
         * @param {int} id - the vendor id that is being taken from the request
         * @param {int} tariffVendorId - the tariffVendor id that is being taken from the request
         * @private
         * @return {undefined}
         */
        _onRouterEditEntity: function(id){

            this._beforeEditEntity(id);

            this._setLabels('edit');

            this.resetForm();

            this.model.set('id', id);

            this.model.fetch({
                success: function(){

                    this._afterEditEntity.apply(this, arguments);

                }.bind(this),
                error: function(){

                    this._afterEditEntity.apply(this, arguments);

                }.bind(this)
            });
            this._showModal();
        },

        /**
         * Method used to show a general error message if the user is
         * browsing the app on mobile
         * @return {undefined}
         */
        showMobileAlert: function()
        {
            var errorMessage = Translator.trans('js.tariff_vendor_create_error_message_mobile');
            this.$el.find('#tariff_vendor-create-general-error-panel')
                .removeClass('hidden')
                .text(errorMessage)
                .fadeTo('slow', 1)
                .delay(3000)
                .fadeTo('slow', 0, function(){
                    this.hideMobileAlert();
                }.bind(this));
        },

        /**
         * Method used to hide the error message if the form is submitted, or the modal has been closed
         * @return {undefined}
         */
        hideMobileAlert: function()
        {
            this.$el.find('#tariff_vendor-create-general-error-panel').addClass('hidden');
        },

        /**
         * Method called after the service drop down gets changed
         * @return {undefined}
         * @private
         */
        _onServiceChange: function(isEdit){

            this._loadServiceForm(isEdit);

        },
        /**
         * Loads the service form according to the service dropdown
         * @param {Function} callback The callback
         * @return {undefined}
         * @private
         */
        _loadServiceForm: function(isEdit){

            var tariffId = 0;
            if(isEdit){
                var url = window.location.pathname;
                tariffId = url.substring(url.lastIndexOf('/') + 1);
            }
            var record = this._getFormRecord();
            var serviceId = record.service;
            var $holder = this._getServiceContainerEl();
            var toggle = this._toggleOfferAssociatedFields.bind(this); // this._toggleServiceField();
            $holder.empty();

            if (!serviceId) {

                return;
            }
            var url = this._getServiceFormUrl(serviceId, tariffId);

            var opts = {
                method      : 'GET',
                dataType    : 'html',
                contentType : 'text/plain'
            };

            toggle();
            var $vendorField = $('#tariffVendorForm-vendor-field');
            z.tariffVendorAdminForm._toggle([$vendorField]);
            z.request.make(url, null, function(jqXhr, status){

                toggle();

                if (status !== 'success') {

                    return;
                }

                $holder.append(jqXhr.responseText);

                this._removeAllServiceFieldValidations(this.model);
                this._getServiceParamsFields(this.model);
                $('#tariffVendorForm-service-field').addClass('chosen-select');
            }.bind(this), opts);

            var opts = {
                method      : 'GET',
                dataType    : 'html',
                contentType : 'text/plain'
            };

            var serviceUrl = this._getServiceVendorsUrl(serviceId);

            z.request.make(serviceUrl, null, function(jqXhr, status){

                toggle();
                if (status !== 'success') {
                    return;
                }

                var response = JSON.parse(jqXhr.responseText);
                response = response.data;

                $vendorField.empty();
                $('.chosen-results').empty()
                var index = 0;

                _.each(response, function(value) {
                    $vendorField.append('<option value="'+value.id+'">'+value.brandName+'</option>');
                    $('.chosen-results').append('<li class="search-choice"><span>'+value.brandName+'</span><a class="search-choice-close" data-option-array-index="'+index+'"></a></li>')
                    index++;
                });
                z.tariffVendorAdminForm._toggle([$vendorField]);
                toggle();
            }.bind(this), opts);
        },
        /**
         *
         * @private
         */
        _getServiceParamsFields: function(model){

            var params = $("#tariffVendorForm-service-container").children();
            params.each(function( index, value ) {
                var fieldName = $(this).data('validation');
                model.validation[fieldName] = [{
                    required: true,
                    msg: Translator.trans('js.error_message_orderform_service_param_required')
                }];
                model.serviceParamsFields.push(fieldName)
                ;
            });
        },
        _removeAllServiceFieldValidations(model){

            _.each(model.serviceParamsFields, function(fieldName){
                delete model.validation[fieldName];
            });
        },
        /**
         * Returns the url where you can find the service form
         * @param {int|string} serviceId The service id
         * @returns {string} The url
         * @private
         */
        _getServiceFormUrl: function(serviceId, tariffId){
            var url =  this.SERVICE_FORM_URL.replace('{service}', serviceId);
            if(typeof tariffId == 'undefined'){
                tariffId = 0;
            }
            var url =  url.replace('{tariff}', tariffId);
            return url;
        },
        /**
         *
         * @param serviceId
         * @returns {string}
         * @private
         */
        _getServiceVendorsUrl: function(serviceId){
            var url =  this.SERVICE_VENDORS_URL.replace('{service}', serviceId);
            return url;
        },
        /**
         * Retrieves the service holder element
         * @returns {object} The service holder
         * @private
         */
        _getServiceContainerEl: function(){
            return this.$('#tariffVendorForm-service-container');
        },
        /**
         * Retrieves the normalized form data
         * @param {boolean} forOffers Return the offer record used for offers
         * @return {object} The form data
         * @private
         */
        _getFormRecord: function(forOffers){

            var record = {
                service: this._getServiceFieldEl().val(),
            };
            return record;
        },
        /**
         * Retrieves the service dropdown element
         * @returns {object} The service holder
         * @private
         */
        _getServiceFieldEl: function(){
            return this.$('#tariffVendorForm-service-field');
        },

        /**
         *
         * @private
         */
        _toggleOfferAssociatedFields: function(){
            var $service = this._getServiceFieldEl();

            var list = [
                $service,
            ];

            this._toggle(list);
        },
        _toggle: function($fields, display, override) {
            $fields = _.isArray($fields) ? $fields : [$fields];

            _.each($fields, function($field){

                var show = function(){
                    $field.removeClass('hidden');
                };

                var hide = function(){
                    $field.addClass('hidden');
                };

                var enable = function(){
                    $field.removeAttr('disabled');
                };

                var disable = function(){
                    $field.attr('disabled', 'disabled');
                };

                var isToggled = _.isUndefined(override) ? this._isToggled($field, display) : !override;
                var toggleOn = display ? show : enable;
                var toggleOff = display ? hide : disable;

                if (isToggled) {

                    toggleOff();

                } else {

                    toggleOn();
                }

                $field.trigger('chosen:updated');

            }, this);
        },
        /**
         * Returns true if the supplied filed is toggled, false otherwise
         * @param {object} $field The field
         * @param {boolean} display The type of toggle: true for display, false for state
         * @returns {boolean} The status
         * @private
         */
        _isToggled: function($field, display){
            var isDisabled = $field.attr('disabled');
            var isHidden = $field.hasClass('hidden');

            return display ? !isHidden : !isDisabled;
        },
        _initServicesValidation: function(){
            var model = this.model;
            var serviceRequiredFields = this._getServiceRequiredFields(model);

            this._removeAllServiceFieldValidations(model);

            _.each(serviceRequiredFields, function(name){

                this._addServiceFieldValidation(name, model);

            }, this);
        },
    });

})(window.z = window.z || {}, _);